import { Loading, WithNativeHTMLProps } from "@kalyzee/kast-web-sdk/web-components";
import React, { ForwardedRef } from "react";
import "./LoadingView.css";

export interface LoadingViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export interface LoadingViewRef {}

export const LoadingView = React.forwardRef(({  message, className, style, ...nativeProps }: LoadingViewProps, forwardRef: ForwardedRef<LoadingViewRef | undefined>) => {
  return (
    <div {...nativeProps} className={className} style={({
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "white",
    
      "--loading-svg-size": "24px",
      "--loading-svg-color": "black",
      "--loading-message-color": "black",
      ...(style ?? {})
    }) as any}>
      <Loading message={message ?? "Chargement en cours"} />
    </div>
  );
});
